import React from 'react';
import { Tab, Tabs } from '~/lib/bn-material-ui';

// TODO consolidate bn-tabs & bn-tabs-v2
export function BnTabs (props) {
  const mergedProps = {
    ...props,
    className: props.className,
  };

  return <Tabs
    variant='scrollable'
    allowScrollButtonsMobile={true}
    {...mergedProps}
  />;
}

export function BnTab(props) {
  const mergedProps = {
    ...props,
    className: props.className,
  };

  return <Tab {...mergedProps} />;
}
